import { required, helpers } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";
import { DateTime } from "luxon";

const { locale } = await useLocale("validation");

export default {
    name: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            required,
        ),
    },
    surname: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            required,
        ),
    },
    gender: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            required,
        ),
    },
    birthDate: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            required,
        ),
        validDate: helpers.withMessage(
            () => locale?.value?.invalid_date ?? validationJson.invalid_date,
            Validator.validDate
        ),
        minValue: helpers.withMessage(
            () => locale?.value?.invalid_date ?? validationJson.invalid_date,
            (value: string) => {
                return DateTime.fromFormat(value, "dd/MM/yyyy") < DateTime.now();
            },
        ),
    },
    birthCountry: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            required,
        ),
    },
    birthCity: {
        required: helpers.withMessage(
            () => locale?.value?.required ?? validationJson.required,
            helpers.withParams(
                { type: "requiredIfBirthCountryIsItalia" },
                (value: string, obj: any) => {
                    const countryValue = obj.birthCountry?.value ?? obj.birthCountry;
                    if (countryValue?.toUpperCase() === "ITALIA") {
                        return helpers.req(value);
                    }
                    return true;
                }
            )
        )
    },
};